import { defineComponent as _defineComponent } from 'vue';
import { BButton, BFormGroup, BModal } from "bootstrap-vue";
import { orderBy } from "lodash";
import isEqual from "lodash.isequal";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { HistoriesFilters } from "@/components/History/HistoriesFilters";
import { useHistoryStore } from "@/stores/historyStore";
import localize from "@/utils/localization";
import FilterMenu from "@/components/Common/FilterMenu.vue";
import Heading from "@/components/Common/Heading.vue";
import HistoryList from "@/components/History/HistoryScrollList.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectorModal',
    props: {
        multiple: { type: Boolean, default: false },
        title: { default: "Switch to history" },
        histories: { default: () => [] },
        additionalOptions: { default: () => [] },
        showModal: { type: Boolean, default: false }
    },
    emits: ["selectHistory", "selectHistories", "update:show-modal"],
    setup(__props, { emit }) {
        const props = __props;
        const propShowModal = computed({
            get: () => {
                return props.showModal;
            },
            set: (val) => {
                emit("update:show-modal", val);
            },
        });
        const selectedHistories = ref([]);
        const filter = ref("");
        const busy = ref(false);
        const showAdvanced = ref(false);
        const modal = ref(null);
        const { pinnedHistories } = storeToRefs(useHistoryStore());
        // retain previously selected histories when you reopen the modal in multi view
        watch(() => propShowModal.value, (show) => {
            if (props.multiple && show) {
                selectedHistories.value = [...pinnedHistories.value];
            }
        }, {
            immediate: true,
        });
        /** if pinned histories and selected histories are equal */
        const pinnedSelectedEqual = computed(() => {
            // uses `orderBy` to ensure same ids are found in both `{ id: string }[]` arrays
            return isEqual(orderBy(pinnedHistories.value, ["id"], ["asc"]), orderBy(selectedHistories.value, ["id"], ["asc"]));
        });
        function selectHistory(history) {
            if (props.multiple) {
                const index = selectedHistories.value.findIndex((item) => item.id == history.id);
                if (index !== -1) {
                    selectedHistories.value.splice(index, 1);
                }
                else {
                    selectedHistories.value.push({ id: history.id });
                }
            }
            else {
                emit("selectHistory", history);
                modal.value?.hide();
            }
        }
        function selectHistories() {
            // set value of pinned histories in store
            emit("selectHistories", selectedHistories.value);
            // set local value equal to updated value from store
            selectedHistories.value = pinnedHistories.value;
            modal.value?.hide();
        }
        function setFilterValue(newFilter, newValue) {
            filter.value = HistoriesFilters.setFilterValue(filter.value, newFilter, newValue);
        }
        // hacky workaround for popovers in date pickers being cutoff
        // https://github.com/galaxyproject/galaxy/issues/17711
        const modalBodyClasses = computed(() => {
            return [
                "history-selector-modal-body",
                showAdvanced.value
                    ? "history-selector-modal-body-allow-overflow"
                    : "history-selector-modal-body-prevent-overflow",
            ];
        });
        return { __sfc: true, props, emit, propShowModal, selectedHistories, filter, busy, showAdvanced, modal, pinnedHistories, pinnedSelectedEqual, selectHistory, selectHistories, setFilterValue, modalBodyClasses, BButton, BFormGroup, BModal, HistoriesFilters, localize, FilterMenu, Heading, HistoryList };
    }
});
